import { GESTION_OPERATIVA_REMOVE_USADO_A_ENTREGAR } from './constants'

export function removeUsadoAEntregar(patente) {
  return {
    type: GESTION_OPERATIVA_REMOVE_USADO_A_ENTREGAR,
    data: { patente },
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_REMOVE_USADO_A_ENTREGAR) {
      if(action.data.patente){
        return {
          ...state,
          sale: {
            ...state.sale,
            Taking_cars: state.sale.Taking_cars.filter((taking_car) => taking_car.license_plate !== action.data.patente)
          },
        }
      } else {
        return {
          ...state,
        }
      }
  }
  else {
       return state
  }    
}

